(function() {
    window.c24.lp.ac.rv = {

        init: function() {
            window.c24.lp.ac.addDefaultQtips('rv');

            $('.mod24ac.rv form').on('submit', function(e) {
                const url = $('input[name=target]:checked', e.target).data('url');
                if (url) {
                    e.preventDefault();
                    this.setAttribute('action', url);
                    this.submit();
                }
            });
        },
    };

    $(document).ready(function() {
        window.c24.lp.ac.rv.init();
    });
})();
